export default "__VITE_ASSET__2r3vv0jK__"